export enum QuizType {
    Unknown = 0,
    Course = 1,
    Topic = 2,
    AwardByCourseQuiz = 3,
    AwardByAwardQuiz = 4
}